import { useContext, useEffect, useState } from 'react'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { SEL_CURRENT_LEVEL_CONFIG } from '../../b.providers/ScenesProvider/selectors'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { SEL_BATTLE_STATE } from '../../c.managers/LevelManager/selectors'
import { BATTLE_STATES, COMMANDERS, Spell } from '../../c.managers/LevelManager/store.d'
import { SEL_LEVEL_SUMMARY, SEL_TREASURES } from '../../c.managers/TerrainManager/selectors'
import { getFlawlessScore } from '../../e.elements/scenes/Graveyards/config'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'
import BaseWindow from './components/BaseWindow/BaseWindow'
import Overlay from './components/Overlay/Overlay'
import { NavContext, NavContextType, useNav } from './ScreensNav'

const EndScreen = ({ ctx }: { ctx: NavContextType }) => {
  const { dismiss, nav } = ctx
  const totalCandies = useScenesStore(s => s.user.candySummary)
  const bestScore = getFlawlessScore()
  const score = totalCandies * 100 / bestScore
  const homeTeam = useScenesStore(s => s.user.team)
  const teamName = homeTeam === CHARACTER_TYPES.JACK ? 'Jack' : 'Witch'

  return (
    <>
      <BaseWindow show>
        <div className={`body-container`}>
          <div className="header-container">
            <span>Well done!</span>
          </div>
          <div className="body-content">
            <div className="body-row no-bottom-line">
              <span style={{ fontSize: '4.5vh' }}>Team {teamName} won</span>
            </div>
            <div className="body-row">
              <div className="body-row-left">Your score</div>
              <div className="body-row-right">{score.toFixed(1)}%</div>
            </div>
            <div
              className="body-row"
              style={{
                // backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg")`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                height: '50%',
                border: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                // color: 'black',
              }}
            >
              <span
                style={{
                  textAlign: 'center',
                  width: '75%',
                  fontSize: '0.65em',
                  lineHeight: '1.2em',
                  textShadow: 'none', //'1px 1px 0 #430064, 2px 2px 0 #430064, 0 0 0 #FFF955'
                }}
              >
                The dawn is here, all the creatures of the night must rest. We will face up soon when night comes and
                the CANDY RIOT breaks out once again.
              </span>
            </div>
            <a
              className="body-row no-bottom-line"
              onClick={() => {
                nav('/credits')
              }}
            >
              <div className="theme-button button-orange-big">THE END</div>
            </a>
          </div>
        </div>
      </BaseWindow>
    </>
  )
}

export default EndScreen
